import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { displayCashAccountType } from '../../../../CashAccount';
import { displayInvestmentType } from '../../../../Investment';
import { displayRealEstateType } from '../../../../RealEstateProperty';
import { CashAccountType, InvestmentType, RealEstateType } from '../../../../generated/graphql';
import { NetWorthListItemCategory, NetWorthListItemRouteSection } from '../netWorthItem.types';
import { NetWorthList, NetWorthListItem } from './NetWorthList';

export const netWorthListAssetItems: (
  t: TFunction<'common'>,
  tCashAccount: TFunction<'cashAccount'>,
  tInvestment: TFunction<'investment'>,
  tRealEstate: TFunction<'realEstate'>
) => NetWorthListItem[] = (t, tCashAccount, tInvestment, tRealEstate) => [
  {
    heading: t('cash-accounts'),
    categories: [
      CashAccountType.CheckingAccount,
      CashAccountType.SavingsAccount,
      CashAccountType.Cash,
      CashAccountType.CertificateOfDeposit,
      CashAccountType.MoneyMarketAccount,
      CashAccountType.CashManagementAccount,
      CashAccountType.TreasuryBill,
    ],
    routeSection: NetWorthListItemRouteSection.CashAccount,
    categoryDisplayFunction: (c) => displayCashAccountType(c as CashAccountType, tCashAccount),
  },
  {
    heading: t('investments'),
    categories: [
      InvestmentType.BrokerageAccount,
      InvestmentType.IndividualRetirementAccount,
      InvestmentType.RothIndividualRetirementAccount,
      InvestmentType.Subsection_401KAccount,
      InvestmentType.RothSubsection_401KAccount,
      InvestmentType.SimpleIndividualRetirementAccount,
      InvestmentType.SimplifiedEmployeePensionAccount,
      InvestmentType.QualifiedTuitionPlan_529,
      InvestmentType.ProfitSharingAccount,
      InvestmentType.DefinedBenefitPlanAccount,
      InvestmentType.HealthSavingsAccount,
      InvestmentType.MinorIndividualRetirementAccount,
      InvestmentType.MinorRothIndividualRetirementAccount,
      InvestmentType.UniversalTrustForMinorAccount,
      InvestmentType.Cryptocurrency,
      InvestmentType.StockOption,
      InvestmentType.PrivateStock,
      InvestmentType.TaxShelteredAnnuity_403BAccount,
      InvestmentType.DeferredCompensationPlan_457BAccount,
      InvestmentType.Annuity,
    ],
    routeSection: NetWorthListItemRouteSection.Investment,
    categoryDisplayFunction: (i) => displayInvestmentType(i as InvestmentType, tInvestment),
  },
  {
    heading: t('real-estate'),
    categories: [
      RealEstateType.PrimaryResidence,
      RealEstateType.BusinessRealEstate,
      RealEstateType.InvestmentRealEstate,
      RealEstateType.SecondHome,
      RealEstateType.Timeshare,
      RealEstateType.Land,
    ],
    routeSection: NetWorthListItemRouteSection.RealEstate,
    categoryDisplayFunction: (r) => displayRealEstateType(tRealEstate, r as RealEstateType),
  },
  {
    heading: t('businesses'),
    categories: [t('business') as NetWorthListItemCategory],
    routeSection: NetWorthListItemRouteSection.Business,
    categoryDisplayFunction: (v) => v,
  },
  {
    heading: t('other'),
    categories: [
      t('note-receivable') as NetWorthListItemCategory,
      t('personal-property-item') as NetWorthListItemCategory,
    ],
    routeSection: NetWorthListItemRouteSection.Other,
    categoryDisplayFunction: (v) => v,
  },
];

export const AddNetWorthItemAssetList = ({ getLinkTo }: { getLinkTo?: (to: string) => string }) => {
  const { t } = useTranslation('common');
  const { t: tInvestment } = useTranslation('investment');
  const { t: tCashAccount } = useTranslation('cashAccount');
  const { t: tRealEstate } = useTranslation('realEstate');

  return <NetWorthList getLinkTo={getLinkTo} items={netWorthListAssetItems(t, tCashAccount, tInvestment, tRealEstate)} />;
};
